<h1>Navigation Menu</h1>
<div class="fake--screen">
  <div class="fake--menu">
      <app-menu [items]="menuItems"></app-menu>
  </div>
</div>

<h1>Navigation Tiered</h1>
<div class="fake--screen">
  <div class="fake--menu">
      <app-tiered-menu [items]="menuItems"></app-tiered-menu>
  </div>
</div>